import React from "react";
import thrash from "../../vendor/thrash.svg";
import rotate from "../../vendor/rotate.svg";
import select from "../../vendor/select.svg";
import "./FilterModal.css";

const FilterModal = ({
  showFilterModal,
  setShowFilterModal,
  filters,
  setFilters,
  handleFilterChange,
  clearFilter,
  getAllFilterOptions,
  filterOptions,
}) => {
  if (!showFilterModal) return null;

  const handleSelectAll = () => {
    const availableOptions = getAvailableOptions();
    if (availableOptions && availableOptions.length > 0) {
      setFilters((prev) => ({
        ...prev,
        [showFilterModal]: [...availableOptions],
      }));
    }
  };

  const handleInvertSelection = () => {
    const availableOptions = getAvailableOptions();
    if (availableOptions && availableOptions.length > 0) {
      const currentSelection = filters[showFilterModal];
      const newSelection = availableOptions.filter(
        (option) => !currentSelection.includes(option)
      );
      setFilters((prev) => ({
        ...prev,
        [showFilterModal]: newSelection,
      }));
    }
  };

  const getAvailableOptions = () => {
    switch (showFilterModal) {
      case "manager":
        return filterOptions.availableManagers || [];
      case "ink":
        return filterOptions.availableInks || [];
      case "company":
        return filterOptions.availableCompanies || [];
      case "vacancy":
        return filterOptions.availableVacancies || [];
      default:
        return [];
    }
  };

  const getDisplayName = () => {
    switch (showFilterModal) {
      case "ink":
        return "ИНК";
      case "company":
        return "компаниям";
      case "vacancy":
        return "вакансиям";
      case "manager":
        return "менеджерам";
      default:
        return "";
    }
  };

  const availableOptions = getAvailableOptions();
  const allOptions = getAllFilterOptions[showFilterModal] || [];

  return (
    <>
      <div className="FilterModal">
        <div className="FilterModal_header">
          <h3>Фильтр по {getDisplayName()}</h3>
          <button
            onClick={() => setShowFilterModal(null)}
            style={{
              border: "none",
              fontSize: "24px",
              background: "transparent",
            }}
          >
            ×
          </button>
        </div>

        <div className="FilterModal_buttons_container">
          <div className="FilterModal_buttons">
            <button onClick={() => clearFilter(showFilterModal)}>
              Очистить фильтр
              <img src={thrash} alt="clean" />
            </button>
            <button
              onClick={() => handleSelectAll()}
              disabled={availableOptions.length === 0}
            >
              Выбрать все ({availableOptions.length})
              <img src={select} alt="select all" />
            </button>
            <button
              onClick={() => handleInvertSelection()}
              disabled={availableOptions.length === 0}
            >
              Инверсия
              <img src={rotate} alt="inverse" />
            </button>
          </div>
          <span className="FilterModal_buttons_available">
            {`Доступно: ${availableOptions.length} из ${allOptions.length}`}
          </span>
        </div>

        <div className="FilterModal_options">
          {allOptions.map((option) => {
            const isSelected = filters[showFilterModal].includes(option);
            const isAvailable = availableOptions.includes(option);

            return (
              <div
                className={`FilterModal_option ${
                  !isAvailable && "FilterModal_option_disabled"
                }`}
                key={option}
              >
                <label>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() =>
                      isAvailable && handleFilterChange(showFilterModal, option)
                    }
                    disabled={!isAvailable}
                  />
                  {option}
                  {!isAvailable && (
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "12px",
                        color: "#999",
                        fontStyle: "italic",
                      }}
                    >
                      (недоступно)
                    </span>
                  )}
                </label>
              </div>
            );
          })}
        </div>
      </div>

      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.4)",
          zIndex: 9,
        }}
        onClick={() => setShowFilterModal(null)}
      />
    </>
  );
};

export default FilterModal;
